<div class="ff-dialog" [class.ff-dialog--mobile-full]="fullScreenOnMobile" role="document">
  <header class="ff-dialog__head">
    <div class="ff-dialog__heading">
      <h2 class="ff-dialog__title">{{ title }}</h2>
      @if (subtitle) {
        <p class="ff-dialog__sub">{{ subtitle }}</p>
      }
    </div>
    <ng-content select="[dialogControls]"></ng-content>
    <button type="button" class="ff-dialog__close" [attr.aria-label]="closeLabel" (click)="closeRequest.emit()">
      <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
    </button>
  </header>
  <div class="ff-dialog__body">
    <ng-content></ng-content>
  </div>
  <ng-content select="[dialogFooter]"></ng-content>
</div>
